// extracted by mini-css-extract-plugin
export default {"main_about":"_about_main_about__LT3IY","divContainer":"_about_divContainer__w9DYJ"};